<template>
  <span>
    <span v-b-tooltip.hover :title="status.title" :class="`badge badge-${status.class}`">
      <font-awesome-icon v-if="hasIcon" :icon="status.icon" />
      <b-icon v-else :icon="getBootstrapIcon" font-scale="1.1" />
    </span>
  </span>
</template>

<script>
import { findIconDefinition } from '@fortawesome/fontawesome-svg-core';

export default {
  props: ['id_status', 'isOutline'],
  data() {
    return {
      bootstrapIcons: {
        clock: 'clock-fill',
        minus: 'dash-circle-fill',
        star: 'star-fill',
        ban: 'x-circle-fill',
        'sack-dollar': 'cash-stack',
        'star-half': 'star-half'
      },
      tipoStatus: {
        1: { title: this.$i18n.t('Aguardando Resultado'), class: 'primary', icon: 'clock' },
        2: { title: this.$i18n.t('Cancelado'), class: 'danger', icon: 'minus' },
        3: { title: this.$i18n.t('Premiado'), class: 'success', icon: 'star' },
        4: { title: this.$i18n.t('Não Premiado'), class: 'danger', icon: 'star' },
        5: { title: this.$i18n.t('Invalidado'), class: 'dark', icon: 'ban' },
        6: { title: this.$i18n.t('Cashout'), class: 'warning', icon: 'sack-dollar' },
        7: { title: this.$i18n.t('Pre-Premiado'), class: 'warning', icon: 'star-half' }
      }
    };
  },
  computed: {
    status() {
      return this.tipoStatus[this.id_status];
    },
    hasIcon() {
      if (!this.status?.icon) return false;

      const solidIcon = findIconDefinition({
        prefix: 'fas',
        iconName: this.status.icon
      });

      const regularIcon = !solidIcon
        ? findIconDefinition({
            prefix: 'far',
            iconName: this.status.icon
          })
        : null;

      return Boolean(solidIcon || regularIcon);
    },
    getBootstrapIcon() {
      return this.bootstrapIcons[this.status.icon] || 'question';
    }
  }
};
</script>

<style lang="scss" scoped></style>
